export const ENTITY_PERSON_ROLE_TYPE_OPTIONS = [
  { value: 'AU', text: 'Auditor' },
  { value: 'BO', text: 'Beneficial Owner' },
  { value: 'D', text: 'Director' },
  { value: 'JR', text: 'Judicial Representative ' },
  { value: 'LR', text: 'Legal Representative ' },
  { value: 'LQ', text: 'Liquidator' },
  { value: 'OT', text: 'Other' },
  { value: 'PT', text: 'Partners' },
  { value: 'SC', text: 'Secretary' },
  { value: 'SH', text: 'Shareholder' },
  { value: 'SG', text: 'Signatory' },
  { value: 'UBO', text: 'Ultimate Beneficial Owner' },
  { value: '-', text: 'Unknown' },
] as const;

export type DirectorRoleType =
  | (typeof ENTITY_PERSON_ROLE_TYPE_OPTIONS)[number]['value']
  | '';
